<template>
<div>

    <div class="row">
        <div class="center" v-if="cart.length">
            <h2> Ваша корзина</h2>
        </div>
        <div v-else class="center">
            <h2> Ваша корзина пуста</h2>

            <router-link to="/">
                <b-btn size="lg" style="background: rgb(86, 77, 118);">Выберите товар из каталога</b-btn>
            </router-link>
        </div>
        <div class="cart" v-if="!isNext">
            <div v-for="(item, index) in cart" :key="index" class="cart-item" :tid="item.id">
                <div class="podzakaz" v-if="item.nal == 'false'">
                    !
                </div>
                <div class="item-img">
                    <img :src="item.img" :alt="item.title">
                    <!--  <div class="item-article">{{ item.id}}</div> -->
                </div>

                <!--                 <div class="item-title">{{ item.title}}</div> -->
                <div class="item-sostav">
                    <h4>{{item.brand}}</h4>{{ item.short}}
                </div>

                <div class="item-price">
                    <div class="item-count">
                        <b-btn variant="outline" @click="plus(item.id)" :disabled="item.count == item.maxCount" size="sm"><i class="fa fa-plus" aria-hidden="true"></i></b-btn>
                        <span class="forcount">{{item.count}}</span>
                        <b-btn variant="outline" @click="minus(item.id)" v-if="item.count !=1" size="sm"><i class="fa fa-minus" aria-hidden="true"></i></b-btn>
                        <b-btn variant="danger" class="remove" @click="remove(item.id)" v-else><i class="fa fa-trash"></i></b-btn>
                    </div>
                    {{getPrice((item.count * item.price).toString())}}<i class="fa fa-rub" area-hidden="true"></i>
                </div>

            </div>
            <div class="zakaz" v-if="zakaz">! Есть товары отсутствующие на складе, предполагаемый срок отгрузки до 60 дней !</div>
        </div>

        <div class="itog" v-if="cart.length">

            <b-btn variant="outline-info" @click="isNext = !isNext" class="next">
                <span v-if="!isNext"> Оформить заказ: {{ getPrice(summCart.toString()) }}<i class="fa fa-rub" area-hidden="true"></i>
                </span>
                <span v-else> Изменить корзину {{ getPrice(summCart.toString()) }}<i class="fa fa-rub" area-hidden="true"></i>
                </span>
            </b-btn>
            <!--b-btn-- variant="success" v-if="!isNext" @click="KomPred()" data-toggle="modal" data-target="#exampleModal">Скачать КП</!--b-btn-->
            <div class="forbtn">
                <FormKP v-if="!isNext" @cloze="KomPred"></FormKP>
                <b-btn class="btn-danger" v-if="!isNext" @click="clearCart()">Очистить корзину</b-btn>

            </div>

        </div>

    </div>
    <div class="row" v-if="isNext && summCart > 0">
        <div class="center">
            <h4>Для oформления заказа заполните форму</h4>
            <b-form @submit.prevent="onSubmit" @reset="onReset">
                <b-form-group id="exampleInputGroup1" label="Ваше имя" label-for="exampleInput1">
                    <b-form-input id="exampleInput1" type="text" v-model="form_fl.name" required placeholder="Введите имя">
                    </b-form-input>
                </b-form-group>

                <b-form-checkbox id="form_ul" v-model="fl" name="form_ul" value="false" unchecked-value="true">
                    Я представитель юридического лица
                </b-form-checkbox>

                <div class="for-fizlico" v-if="fl == 'true'">
                    <div class="form-group">
                        <label for="fl_phone">Ваш телефон</label>

                        <masked-input id="fl_phone" mask="\+\7 (111)11-11111" type="text" v-model="form_fl.phone" required class="form-control" placeholder="Введите телефон">
                        </masked-input>
                    </div>
                    <b-form-group id="form_fl_email" label="Электронная почта" label-for="fl_email">
                        <b-form-input id="fl_email" type="email" v-model="form_fl.email" required>
                        </b-form-input>
                    </b-form-group>

                    <b-form-group label="Способ оплаты" label-for="paiment">
                        <b-form-select id="paiment" :options="payment" required v-model="form_fl.payment">
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Способ доставки" label-for="fl_delivery">
                        <b-form-select id="fl_delivery" :options="delivery" required v-model="form_fl.delivery" @change="changeDelivery()">
                        </b-form-select>
                    </b-form-group>

                    <b-form-group label="Адрес доставки" label-for="fl_adress" v-if="form_fl.delivery !='Самовывоз'">
                        <b-form-input id="fl_adress" type="text" v-model="form_fl.adress" required placeholder="Заполните адрес">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Выберите ТК" label-for="fl_tk_delivery" v-if="form_fl.delivery == 'Доставка в регионы РФ'">
                        <b-form-select id="fl_tk_delivery" :options="tk_delivery" required v-model="form_fl.tk_delivery">
                        </b-form-select>
                    </b-form-group>
                    <p v-if="form_fl.delivery == 'Доставка в регионы РФ'">Ознакомиться с условиями доставки в регионы РФ, посчитать примерную стоимость доставки можно на странице <router-link to="/clients">Клиентам</router-link> в разделе "Порядок работы"</p>
                </div>
                <div class="for-urlico" v-else>
                    <b-form-group id="form_ul_name" label="Наименование организации" label-for="ul_name">
                        <b-form-input id="ul_name" type="text" v-model="form_ul.name" required>
                        </b-form-input>
                    </b-form-group>

                    <b-form-group id="form_ul_inn" label="ИНН/КПП" label-for="ul_inn">
                        <b-form-input id="ul_inn" type="text" v-model="form_ul.inn" required>
                        </b-form-input>
                    </b-form-group>

                    <b-form-group id="form_ul_uradres" label="Юридический адрес" label-for="ul_uradres">
                        <b-form-input id="ul_uradres" type="text" v-model="form_ul.uradres" required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="form_ul_faktadres" label="Фактический адрес" label-for="ul_faktadres">
                        <b-form-input id="ul_faktadres" type="text" v-model="form_ul.faktadres" required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="form_ul_phone" label="Контактный телефон" label-for="ul_phone">
                        <masked-input id="ul_phone" class="form-control" mask="\+\7 (111)11-11111" type="text" v-model="form_ul.phone" required>
                        </masked-input>
                    </b-form-group>
                    <b-form-group id="form_ul_email" label="Электронная почта" label-for="ul_email">
                        <b-form-input id="ul_email" type="text" v-model="form_ul.email" required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="form_ul_bankname" label="Наименование банка" label-for="ul_bankname">
                        <b-form-input id="ul_bankname" type="text" v-model="form_ul.bankname" required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="form_ul_bankBIK" label="БИК банка" label-for="ul_bankBIK">
                        <b-form-input id="ul_bankBIK" type="text" v-model="form_ul.bankBIK" required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="form_ul_bankRS" label="Номер расчетного счета" label-for="ul_bankRS">
                        <b-form-input id="ul_bankRS" type="text" v-model="form_ul.bankRS" required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="form_ul_contact" label="ФИО Контактного лица организации" label-for="ul_contact">
                        <b-form-input id="ul_contact" type="text" v-model="form_ul.contact">
                        </b-form-input>
                    </b-form-group>

                </div>
                <div class="captcha">
                    <div class="img-cap">
                        <img :src="'captcha.php'" alt="captcha">
                    </div>
                    
                    <b-form-group id="form_captcha" label="Защита от спама" label-for="captcha">
                        <b-form-input id="captcha" type="text" v-model="reg" placeholder="Введите защитный код с картинки" required>
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="zakaz" v-if="zakaz">Есть товары отсутствующие на складе. Реальные сроки поставки сообщат вам по телефону или емайл после оформления Вами заказа.</div>
                <div class="foralert" v-if="alert" @click="alert = false">
                    <Alert :msg="msg">

                    </Alert>

                </div>
                
                <b-button type="submit" variant="success">Оформить заказ</b-button>
                <b-button type="reset" variant="danger">Очистить форму</b-button>
            </b-form>
        </div>

    </div>

</div>
</template>

<script>
import FormKP from '../components/FormKP'
import Alert from '../components/Alert'
import pdfMake from "pdfmake/build/pdfmake.min.js";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {

    data() {
        return {
            isNext: false,
            form_ul: {},
            form_fl: {
                delivery: 'Самовывоз'
            },
            payment: ['ОН-ЛАЙН оплата картой', 'Наличный расчёт', 'Терминал (Безналичный расчёт)'],
            delivery: ['Самовывоз', 'Доставка по г.Березники', 'Доставка в регионы РФ'],
            tk_delivery: ['Деловые Линии', 'СДЭК', 'ПЭК', 'ЖелДорЭкспедиция', 'Экспресс-Авто', 'GTD транспортная компания', 'Boxberry'],
            alert: false,
            msg: {},
            fl: 'true',
            reg:''

        }

    },
    computed: {
        summCart() {
            return this.$store.getters['cart/summ']
        },
        cart() {
            return this.$store.getters['cart/products']
        },
        cnt() {
            return this.$store.getters['cart/cnt']
        },
        zakaz() {
            let z = false
            this.cart.forEach(i => {
                if (i.nal == 'false') {
                    z = true
                }
            })
            return z
        },

    },

    methods: {
        onSubmit() {
            this.alert = false
            var client = {}
            if (this.fl == 'true') {
                client = this.form_fl
                client.fl = 'true'
                client.reg = this.reg
            } else {
                client = this.form_ul
                client.fl = 'false',
                client.reg = this.reg
            }

            this.$http.post('order.php', {
                    'client': client,
                    'cart': this.cart,
                    'summ': this.summCart
                })
                .then(d => {
                    let data = d.body
                    if(typeof(data) == 'string'){
                        this.msg = {
                            type: 'error',
                            arr: ['Ошибка сервера.',data]
                            }
                            this.alert = true
                    } 
                    if(typeof(data) == 'object'){
                    
                        if (data.payment == 'online') {
                            if (data.type == 'success') {
                                localStorage.setItem('orderId',data.msg.orderId)
                                localStorage.setItem('cart',JSON.stringify(this.cart))

                                window.location.href = data.msg.formUrl
                            } else {
                              localStorage.setItem('cart',JSON.stringify(this.cart))
                              localStorage.setItem('orderId','123456789')

                                this.msg = {
                                type: data.type,
                                arr: data.msg
                                }
                                this.alert = true
                            }

                        } else {
                                
                           if(data.type == 'success' && data.order != ''){
                                 this.msg = {
                                type: data.type,
                                arr: data.msg
                             }
                            this.alert = true

                            setTimeout( ()=>{
                                this.clearCart()
                                this.onReset()
                            },5000)

                            } else{
                                this.msg = {
                                type: data.type,
                                arr: data.msg
                                }
                                this.alert = true

                            }

                           

                        }
                    }
                })

        },
        KomPred(user) {

            var tab = []
            tab.push([{
                    text: '№ по каталогу',
                    alignment: 'center'

                },
                {
                    text: 'Наименование',
                    alignment: 'center'
                },
                {
                    text: 'Кол-во',
                    alignment: 'center'
                },
                {
                    text: 'Цена',
                    alignment: 'center'
                },
                {
                    text: 'Сумма',
                    alignment: 'center'
                },
                {
                    text: 'Срок поставки',
                    alignment: 'center'
                }

            ])

            function Srok(i) {
                var srok = ''
                 if (i.sklad == 'ligasound') {
                    srok = '1-2 дня'
                }
                if (i.sklad != 'ligasound' && i.nal == 'true') {
                    srok = '10 дней'
                }
                if (i.sklad != 'ligasound' && i.nal == 'false') {
                    srok = '60 дней*'
                }
                return srok

            }

            this.cart.forEach((i, index) => {
                const row = [i.id, i.short, i.count.toString(), i.price.toString() + ' руб.', (+i.count * +i.price).toString() + ' руб.', Srok(i)]
                tab.push(row)
            })

            const doc = {
                ownerPassword: '123456',
                permissions: {
                    printing: 'highResolution',
                    modifying: false,
                    copying: false
                },
                content: [{
                        text: 'Сформировано автоматически ' + new Date().toLocaleDateString() + ' на сайте www.ligasound.ru в ' + new Date().toLocaleTimeString(),
                        alignment: 'right',
                        fontSize: 8
                    },
                    {
                        text: ' '
                    },

                    {
                        text: 'Коммерческое предложение',
                        alignment: 'center',
                        fontSize: 15,
                        bold: true
                    },
                    {
                        text: new Date().toLocaleDateString(),
                        alignment: 'center',
                        fontSize: 10
                    },
                    {
                        columns: [{
                                width: 100,
                                text: 'Поставщик',
                                bold: true
                            },
                            {
                                width: 'auto',
                                text: "Общество с ограниченной ответственностью \"ЛИГА САУНД СИСТЕМ\" \n ИНН 5911069479, КПП 591101001, ОГРН 1135911001148, ОКПО 24063531 \n 618419, Пермский край г. Березники, ул. Карла Маркса, дом 48, офис 202",
                                fontSize: 10,
                                margin: [0, 0, 0, 5]
                            }

                        ]
                    },

                    {
                        table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            headerRows: 1,
                            widths: [50, '*', 20, 70, 70, 70],

                            body: tab

                        }
                    },
                    {
                        text: 'Всего наименований ' + this.cnt + ' на сумму ' + this.summCart + ' руб. без НДС',
                        bold: true,
                        alignment: 'right',
                        margin: [0, 5, 0, 0]
                    },
                    {
                        text: '(НДС не облагается на основании ст. 346.12 и 346.13 главы 26.2 НК РФ)',
                        fontSize: 8,
                        alignment: 'right'

                    },
                    {
                        text: ' ',
                        fontSize: 15
                    },

                    {
                        text: '*- товар отсутствует на удаленном складе. Поставка производится под заказ. Срок поставки может отличаться от указанного',
                        fontSize: 8
                    },
                    {
                        text: ' ',
                        fontSize: 15
                    },
                    {
                        text: 'Предложение действительно в течениe 30 дней.',
                        fontSize: 8
                    },
                    {
                        text: 'Самовывоз со склада Поставщика.',
                        fontSize: 8
                    },
                    {
                        text: 'Поставщик является официальным дилером.',
                        fontSize: 8
                    },
                    {
                        text: 'Весь товар новый, завезен официально на территорию РФ.',
                        fontSize: 8
                    },
                    {
                        text: 'Поставщик является субъектом малого предпринимательства.',
                        fontSize: 8
                    },
                    {
                        text: ' ',
                        fontSize: 8
                    },
                    {
                        text: 'Данное предложение не является офертой, для оплаты необходимо выписать счет.',
                        fontSize: 8
                    },

                ]
            }

            let pdf = pdfMake.createPdf(doc)

            this.$http.post('pdf.php', {
                "file": pdf,
                "user": user

            }).then(d => {
                pdf.download('business_offer_' + new Date().toLocaleDateString() + '.pdf')
            })

        },
        onReset() {
            this.form = {
                fl: 'true',
                ul: {}
            }
        },
        getPrice(price) {
           let reg = /(\d)(?=(\d\d\d)+([^\d]|$))/g
            return price.replace(reg, '$1 ')
        },

        clearCart() {

            this.$store.commit('cart/clear')
            localStorage.clear()
        },
        plus(id) {
            this.$store.commit('cart/plus', id)

        },
        minus(id) {
            this.$store.commit('cart/minus', id)

        },
        remove(id) {
            let del = confirm('Вы действительно хотите удалить товар из корзины?')
            if (del) {
                this.$store.commit('cart/remove', id)
            }
        },
        changeDelivery() {
            if (this.form_fl.delivery == 'Самовывоз') {
                this.form_fl.adress = 'Самовывоз'
            } else {
                this.form_fl.adress = ''
            }
            if (this.form_fl.delivery != 'Доставка в регионы РФ') {
                this.form_fl.tk_delivery = ''
                this.form_fl.adress = ''
            }

        }

    },
    components: {
        FormKP,
        Alert
    }

}
</script>

<style scoped>
.foralert {
    cursor: pointer;
}

.podzakaz {
    color: red;
    position: absolute;
    font-size: 40px;
    top: -15px;
    z-index: 2;
    left: -10px;
    font-weight: bold;
}

.zakaz {
    margin: 5px auto;
    color: red;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
}

.fa-rub {
    font-size: 20px;
}

.center {
    width: 100%;
    text-align: center;
}

.cart {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    margin-top: 15px;
}

.cart-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    border: 1px solid rgb(86, 77, 118);
    align-items: center;
    padding: 0px 5px;
    max-width: 85%;
    margin: 5px auto;
    z-index: 5;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 5px 5px 5px #564d76a6;
    position: relative;

}

.cart-item div {
    text-align: center;
    padding: 5px 10px;
}

.item-img {
    width: 20%;
    position: relative;
    max-width: 135px;
}

.item-img img {
    max-width: 100%;
    max-height: 100px;
}

.item-article {
    position: absolute;
    bottom: 5px;
    left: 3px;
    color: red;
    font-size: 30px;
    font-weight: 700;
    background-color: #ffffffd9;
    border-radius: 61%;
    text-shadow: 2px 2px 1px black;
}

.item-title {
    min-width: 125px;
    color: #FF9800;
    text-shadow: 1px 1px 1px red;
    background-color: #ffffffba;
    z-index: 3;
}

.item-sostav {
    flex-grow: 1;
}

.item-count {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.item-count .btn-outline {
    background-color: transparent;
    border: 1px solid rgb(86, 77, 118);

}

.forcount {
    margin-right: 4px;
}

.item-price {
    font-size: 20px;
    font-weight: 500;
    font-style: italic;
    text-shadow: 1px 1px 2px red;
    min-width: 125px;
}

.itog {
    width: 100%;
    text-align: center;

}

.itog span {
    font-weight: 500;
    font-style: italic;
    text-shadow: 1px 1px 2px red;
    min-width: 125px;
    font-size: 2rem;
}

.next {
    margin: 5px 0px;
    color: #000000;
    border-color: rgb(86, 77, 118)
}

.next:hover {
    color: #fff;
    background-color: rgb(86, 77, 118);
    border-color: rgb(86, 77, 118);
}

.forbtn {
    display: flex;
    justify-content: center;
    align-items: center;
}

h4 {
    margin: 0 15px;
}

button {
    margin: 5px;
}

form {
    max-width: 500px;
    margin: 10px auto;
}

#ul_phone {
    width: 100%;
}

.form-group {
    text-align: left;
}
.img-cap{
    width: 125px;
    margin: 5px auto;
}

@media (max-width: 800px) {
    .item-sostav {
        display: none;
    }

    h2 {
        font-size: 1.2rem;
    }

    form {
        max-width: 300px
    }

}

@media (max-width: 400px) {
    .item-title {
        display: none;
    }

    .itog span {
        font-size: 1.3rem;
    }

    .item-img img {
        max-width: 85px;
    }

    .zakaz {
        font-size: 13px;
    }

}
</style>
